<div class="share-link-modal">
  <h3 class="share-link-modal__title" i18n>Link to the recorded sound</h3>

  <div class="share-link-modal-link">
    <input type="text" class="share-link-modal-link__input" [value]="recordUrl" (focus)="onInputFocus()" #inputElement>

    <div class="share-link-modal-link__buttons">
      <button class="share-link-modal-link__button share-link-modal-link__button--copy" (click)="onCopyButtonClick()">
        <ng-container *ngIf="copied === false" i18n>Copy</ng-container>
        <ng-container *ngIf="copied === true" i18n>Copied</ng-container>
      </button>
      <button class="share-link-modal-link__button share-link-modal-link__button--open" (click)="onOpenButtonClick()" i18n>Open</button>
    </div>
  </div>

  <div class="share-link-modal__text" i18n>
    The recording will be stored 2 weeks from the date of last access to it. The total storage time is unlimited.
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/rec/components/share/share-link/share-link-modal/share-link-modal.component.html